module.exports = __webpack_public_path__ + "static/img/primary_logo.ef0e6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/primary_logo.png
// module id = bSQZ
// module chunks = 10